var chunkToChildrenMap = {
	"node_modules_cornerstonejs_tools_dist_esm_enums_index_js": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	],
	"extensions_cornerstone-dicom-sr_src_index_tsx": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx",
		"extensions_cornerstone-dicom-sr_src_components_OHIFCornerstoneSRViewport_tsx"
	],
	"extensions_measurement-tracking_src_index_tsx": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx",
		"extensions_cornerstone-dicom-sr_src_components_OHIFCornerstoneSRViewport_tsx",
		"extensions_measurement-tracking_src_viewports_TrackedCornerstoneViewport_tsx"
	],
	"extensions_cornerstone-dicom-seg_src_index_tsx": [
		"vendors-node_modules_cornerstonejs_ai_dist_esm_index_js-node_modules_cornerstonejs_core_dist_-1038f6",
		"extensions_cornerstone_src_components_NavigationComponent_NavigationComponent_tsx-extensions_-cc794b",
		"extensions_cornerstone-dicom-seg_src_viewports_OHIFCornerstoneSEGViewport_tsx"
	],
	"extensions_cornerstone-dicom-pmap_src_index_tsx": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx",
		"extensions_cornerstone-dicom-pmap_src_viewports_OHIFCornerstonePMAPViewport_tsx"
	],
	"node_modules_cornerstonejs_tools_dist_esm_enums_index_js-extensions_cornerstone-dynamic-volum-7497e5": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	],
	"extensions_dicom-pdf_src_index_tsx": [
		"extensions_dicom-pdf_src_viewports_OHIFCornerstonePdfViewport_tsx"
	],
	"extensions_dicom-video_src_index_tsx": [
		"extensions_dicom-video_src_viewports_OHIFCornerstoneVideoViewport_tsx"
	],
	"extensions_tmtv_src_index_tsx": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	],
	"node_modules_cornerstonejs_tools_dist_esm_enums_index_js-extensions_test-extension_src_index_tsx": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	],
	"extensions_cornerstone-dicom-rt_src_index_tsx": [
		"vendors-node_modules_cornerstonejs_tools_dist_esm_utilities_segmentation_index_js",
		"vendors-node_modules_cornerstonejs_tools_dist_esm_index_js",
		"vendors-node_modules_cornerstonejs_calculate-suv_dist_calculate-suv_esm_js-node_modules_brows-f8a8b3",
		"vendors-node_modules_cornerstonejs_ai_dist_esm_index_js-node_modules_cornerstonejs_core_dist_-1038f6",
		"extensions_default_src_index_ts",
		"extensions_cornerstone_src_components_NavigationComponent_NavigationComponent_tsx-extensions_-cc794b",
		"extensions_cornerstone-dicom-rt_src_viewports_OHIFCornerstoneRTViewport_tsx"
	],
	"extensions_cornerstone-dicom-seg_src_viewports_OHIFCornerstoneSEGViewport_tsx": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	],
	"extensions_cornerstone-dicom-rt_src_viewports_OHIFCornerstoneRTViewport_tsx": [
		"extensions_cornerstone_src_Viewport_OHIFCornerstoneViewport_tsx"
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));